'use client';

import React from 'react';

import { SeatCategory } from '@cineamo/ui/src/seat-map/typedefs';

import { useCartProvider } from '@cineamo/composables/src/providers/cartProvider';

import SeatMapLegend, { type SeatMapLegendFurniture, type SeatMapLegendProps } from './SeatMapLegend';

type BookingFooterProps = {
    seatCategories: SeatCategory[];
    hasTables?: boolean;
    hasWheelchairSeats?: boolean;
    furniture?: SeatMapLegendFurniture;
    showcase?: SeatMapLegendProps['showcase'];
};

const BookingFooter: React.FC<BookingFooterProps> = ({
    seatCategories,
    hasTables,
    hasWheelchairSeats,
    furniture,
    showcase
}) => {
    const { currentStep } = useCartProvider();
    let footerView: React.JSX.Element | undefined;
    switch (currentStep) {
        // Only beside the seat map; the payment step shows the payment form there.
        case '01_seat_picking':
        case '01.5_cart':
            footerView = (
                <SeatMapLegend
                    seatCategories={seatCategories}
                    renderSeatTypes={{
                        unavailable: true,
                        selected: true,
                        wheelchair: hasWheelchairSeats,
                        table: hasTables,
                        ...furniture
                    }}
                    showcase={showcase}
                    className="py-24 px-48 hidden lg:flex"
                />
            );
            break;
    }

    return footerView;
};

export default BookingFooter;
